import connectionProxy from './connectionProxy'

export const getOverview = id => connectionProxy.http.get(`areas/${id}/panorama`);

export const getOverviewList = (id, kind_id) => connectionProxy.http.get(`areas/${id}/panorama_lista?kind_id=${kind_id}`)



// WEBPACK FOOTER //
// ./src/api/overview.js